import { useEffect, useRef, useState } from "react"
import "./custom-filter.scss"

function CustomFilter({ filterData, currentValues = null, selectionChange, wrapperClass, isAdmin = false }) {
  const [buttonText, setButtonText] = useState(() => {
    return filterData.filterOptions.find((ele) => ele.optionValue === filterData.filterValue)?.displayText
  })

  // integration-test-03 #3: this dropdown is React-CONTROLLED (open state below) rather than
  // driven by Bootstrap's `data-bs-toggle` global document-delegated JS. Coexisting Bootstrap
  // dropdown JS and MUI's <Menu> (a Modal with a focus-trap) interfere on WebKit/Safari — after
  // a MUI menu closes, the Bootstrap toggle stopped opening until a reload. Controlling open
  // state in React (and toggling the Bootstrap `.show` CSS class ourselves) removes that global
  // JS dependency entirely, so the conflict cannot occur. Styling classes are unchanged.
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)

  const handleOptionSelect = (selectedOption) => {
    setButtonText(selectedOption.displayText)
    setOpen(false)
    selectionChange(filterData.filterKey, selectedOption)
  }

  const shouldHideFilter = () => {
    // Hide admin filters for non-admins
    if (filterData.adminOnly === true && isAdmin === false) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (currentValues && filterData?.filterKey && currentValues[filterData.filterKey]) {
      const selectedOption = filterData.filterOptions.find((ele) => ele.optionValue === currentValues[filterData.filterKey])
      setButtonText(selectedOption?.displayText)
    }
  }, [currentValues])

  // Close on an outside click / Escape while open (replaces Bootstrap's auto-dismiss).
  useEffect(() => {
    if (!open) return undefined
    const onDocPointerDown = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false)
      }
    }
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false)
    }
    document.addEventListener("mousedown", onDocPointerDown)
    document.addEventListener("keydown", onKeyDown)
    return () => {
      document.removeEventListener("mousedown", onDocPointerDown)
      document.removeEventListener("keydown", onKeyDown)
    }
  }, [open])

  return (
    <div className={`filter-box-container ${wrapperClass ?? ""} ${shouldHideFilter() ? "d-none" : ""}`}>
      <div className="filter-name">{filterData.filterLabel}</div>
      <div className={`dropdown filter-trigger-wrapper ${open ? "show" : ""}`} ref={wrapperRef}>
        <button
          type="button"
          className={`btn button-filter dropdown-toggle c-font-12 ellpsis-overflow ${open ? "show" : ""}`}
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className="btn-text">{buttonText}</span>
          <span className="icon-wrapper ms-2">
            <i className="fa-solid fa-angle-down"></i>
          </span>
        </button>
        <ul className={`dropdown-menu ${open ? "show" : ""}`}>
          {filterData.filterOptions.map((optionData, optionIndex) => (
            <li key={`dropdown-${optionIndex}`}>
              <div
                className={`dropdown-item ${optionData.displayText === buttonText ? "active" : ""}`}
                onClick={() => handleOptionSelect(optionData)}
              >
                {optionData.displayText}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default CustomFilter
